/*
 * Copyright (c) 2023. Bolmate B.V.
 */
import './style/subscriptionCoupon.scss';

import {ChangeFunction, CloseButton, ErrorType, Loader, preventDefault, WithBackground} from '@dvrd/dvr-controls';

import React, {KeyboardEventHandler, MouseEventHandler} from 'react';

import {useTranslation} from 'react-i18next';

import {BolmateButton, BolmateInput} from '../../../controls';

interface Props {
    onClose: MouseEventHandler;
    onChangeCoupon: ChangeFunction<string>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    active: boolean;
    loading: boolean;
    error: ErrorType;
    coupon: string;
}

export default function SubscriptionCoupon(props: Props) {
    const {t} = useTranslation();
    const {coupon, onChangeCoupon, loading, onSubmit, onClose, error, active} = props;

    function renderBody() {
        return (
            <form className='body-container' onSubmit={preventDefault}>
                <Loader active={loading} />
                <p className='description'>
                    {t(
                        'settings.subscription.couponInfo',
                        'Vul hieronder een coupon in om toe te passen op jouw abonnement.'
                    )}
                </p>
                <BolmateInput
                    onChange={onChangeCoupon}
                    value={coupon}
                    label={t('settings.subscription.coupon', 'Coupon')}
                    inputProps={{placeholder: t('settings.subscription.coupon', 'Coupon')}}
                    onEnter={onSubmit}
                    autoFocus
                />
                {!!error && <label className='red-text'>{error}</label>}
            </form>
        );
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='subscription-coupon default-popup'>
                <div className='header-container'>
                    <label className='header-title'>
                        {t('settings.subscription.applyCouponTitle', 'Coupon toepassen')}
                    </label>
                    <CloseButton onClick={onClose} />
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BolmateButton
                        onClick={onClose}
                        label={t('settings.subscription.cancel', 'Annuleren')}
                        disabled={loading}
                        secondary
                    />
                    <BolmateButton
                        onClick={onSubmit}
                        label={t('settings.subscription.apply', 'Toepassen')}
                        disabled={loading || !coupon.length}
                    />
                </div>
            </div>
        </WithBackground>
    );
}
